import type { IconSvgObject } from './types';

const TouchpadOffIcon: IconSvgObject = [
  ["path", { d: "M20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4M9 4H20C21.1046 4 22 4.89543 22 6V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 14H14M22 14H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 14V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TouchpadOffIcon;
